import axios from "axios";
import { useAuthStore } from "../stores/auth";


const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL, // global API URL
  // withCredentials: true, 
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const auth = useAuthStore();
  if (auth.token) {
    config.headers.Authorization = `Bearer ${auth.token}`;
  }
  // GET requests to the same URL are made under different accounts (e.g. the
  // "login as staff" flow, where several sessions hit /fecthPerms with an
  // identical URL). The browser HTTP cache keys on URL, not on the
  // Authorization header, so without this it can silently serve a previous
  // user's cached response. Force revalidation on every request.
  config.headers["Cache-Control"] = "no-cache";
  config.headers["Pragma"] = "no-cache";
  return config;
});



// ✅ Response interceptor
api.interceptors.response.use(
  (response) => response, // pass through if success
  (error) => {
    if (error.response && error.response.status === 401) {
      const auth = useAuthStore();
      auth.clearAuth();

      // Optional: redirect to login page
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);
export default api;
